import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static get targets() {
        return ['value', 'input', 'category','documentType', 'error']
    }

    static values = {
        maxSize: { type: Number, default: 10 }
    }

    connect() {
    }

    display(event) {
        const file = event.target.files[0];

        if (file) {
            // Validate file size (1 KB to maxSize MB)
            const minSize = 1024; // 1 KB
            const maxSize = (this.maxSizeValue || 10) * 1024 * 1024; // MB from setting

            if (file.size < minSize) {
                this.showError('Datei ist zu klein. Mindestgröße: 1 KB');
                event.target.value = '';
                return;
            }

            if (file.size > maxSize) {
                this.showError(`Datei ist zu groß. Maximale Größe: ${this.maxSizeValue || 10} MB`);
                event.target.value = '';
                return;
            }

            // Validate file type (PDF only)
            if (file.type !== 'application/pdf') {
                this.showError('Nur PDF-Dateien sind erlaubt');
                event.target.value = '';
                return;
            }
        }

        const fileName = event.target.value.split('\\').pop();
        this.valueTarget.innerHTML = fileName;

        // Hide error message when file is selected
        if (this.hasErrorTarget) {
            this.errorTarget.style.display = 'none';
        }

        if (this.documentTypeTarget) {
            this.documentTypeTarget.classList.remove('hidden').add('animate__animated', 'animate__fadeIn');
        }
        // get all attachment categories into an array from /attachment_categories.json
        // const attachment_categories = JSON.parse('/attachment_categories.json')
        //
        //
        // if (fileName.includes('Bewerbung')) {
        //     this.categoryTarget.value = 'Bewerbung';
        // } else if (fileName.includes('Anschreiben')) {
        //     this.categoryTarget.value = 'Lebenslauf';
        // } else if (fileName.includes('Lebenslauf')) {
        //     this.categoryTarget.value = 'Lebenslauf';
        // } else {
        //     this.categoryTarget.value = 'Sonstiges';
        // }

    }

    showError(message) {
        // Create or update error message
        let errorElement = this.element.querySelector('.file-error-message');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'file-error-message text-red-600 text-sm mt-2';
            this.element.appendChild(errorElement);
        }
        errorElement.textContent = message;
        errorElement.style.display = 'block';

        // Clear file input
        this.valueTarget.innerHTML = 'Keine Datei hochgeladen';
    }

    validate() {
        if (this.hasErrorTarget && this.inputTarget.files.length === 0) {
            this.errorTarget.style.display = 'block';
            return false;
        }
        return true;
    }
}